import React, { useEffect, useState } from "react";
import { IonSpinner } from "@ionic/react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { CancelOutlined } from "@mui/icons-material";
import { useDrag } from '@use-gesture/react';
import { useSpring, animated } from '@react-spring/web';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import "./FAQ.scss"
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LogoutIcon from '@mui/icons-material/Logout';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import API from "../../../services";
import { useTranslation } from "../../../hooks/useTranslation";
import { connect } from "react-redux";
import { RootState } from "../../../models/RootState";
// Add the new types at the top of the file
interface ContentData {
  content: string;
  redirectionUrl: string;
  priority: number;
}

interface ContentResp {
  status: string;
  errorDescription: string;
  data: ContentData[];
}

interface FAQProps {
  userDetails?: any;
  dynamicTextColors?: any;
}

const FAQ: React.FC<FAQProps> = ({ userDetails, dynamicTextColors }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [FAQData, setFAQData] = useState<ContentData[]>([]);
  const navigate = useNavigate();

  // Get dynamic text color classes from Redux instead of calling function
  const textColorClass = dynamicTextColors?.pageTextColorClass || '';
  const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';

  const handleBackClick = () => {
    navigate(-1);
  };

  const getFAQInfo = async () => {
    setLoading(true);

    let response;
    try {
      response = await API.post(`/webapp/get-content`, {
        tag: "FAQ"
      });
    } catch (e) {
      console.log(e);
      setLoading(false);
      return;
    }

    if (response.data.status !== "RS_OK") {
      navigate("/home");
    }

    if (response && response.data?.data) {
      setFAQData(response.data.data);
    }
    setLoading(false);
  };

  const handleContentClick = (redirectionURL: string) => {
    if (redirectionURL && redirectionURL.trim() !== "") {
      navigate(redirectionURL);
    }
  };

  const renderFAQContent = () => {
    if (!FAQData || FAQData.length === 0) {
      return <div className={textColorClass === 'dark-text' ? 'text-black' : 'text-white'}>{t("profile.noFaqContentAvailable")}</div>;
    }

    return FAQData.map((item, index) => (
      <div 
        key={index} 
        className={`mb-2 hover:bg-opacity-80 transition-all ${textColorClass}`}
        onClick={() => handleContentClick(item.redirectionUrl)}
        style={{ cursor: item.redirectionUrl && item.redirectionUrl.trim() !== "" ? 'pointer' : 'default' }}
      >
        <div 
          className=""
          dangerouslySetInnerHTML={{ __html: item.content }}
        />
        {/* {item.redirectURL && item.redirectURL.trim() !== "" && (
          <div className="text-blue-400 text-sm mt-2">
            Click to learn more →
          </div>
        )} */}
      </div>
    ));
  };

  useEffect(() => {
    getFAQInfo();
  }, []);

  return (
    <>
      <div className={`flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] faq ${textColorClass}`}>
        <header className={`flex gap-3 items-center self-start text-base font-medium text-center mb-[0.5rem] ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
        <div>
            <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                onClick={() => handleBackClick()}
            >
                <ArrowBackIcon
                    className={`aspect-square w-[18px] ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                    style={{ width: '20px', height: '20px' }}
                />
            </div>
        </div>
        <h1 className="text-[1.2rem] font-medium">{t("profile.frequentlyAskedQuestions")}</h1>
        </header>
        <div className="mt-2">
          {loading ? (
            <div className="flex justify-center items-center py-8">
              <IonSpinner name="crescent" />
            </div>
          ) : (
            renderFAQContent()
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    userDetails: state.userDetails?.userDetails,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
  };
};

export default connect(mapStateToProps)(FAQ);
